var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"HighStock flx1",staticStyle:{"height":"370px"},attrs:{"id":_vm.chartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }